import service from '@/assets/js/request'

export const login = (data = {}) => {
  return service({
    url: '/api/v3/login',
    method: 'get',
    params: data
  })
}

export const logout = (data = {}) => {
  return service({
    url: '/api/v3/logout',
    method: 'get',
    params: data
  })
}

// 获取当前登录用户信息
export const getUserInfo = (data = {}) => {
  return service({
    url: '/api/v3/currentUser',
    method: 'get',
    params: data
  })
}

// 获取配置信息
export const getUserConfig = () => {
  return service({
    url: '/api/v3/appconfigs',
    method: 'get'
  })
}

// 查询主菜单
export const getMenu = (data = {}) => {
  return service({
    url: '/api/v3/menu/lists',
    method: 'get',
    params: data,
    timeout: 30 * 1000
  })
}

// 查询导航栏菜单
export const getNav = (data = {}) => {
  return service({
    url: '/api/v3/navigation/lists',
    method: 'get',
    params: data
  })
}

// 消息中心：未读消息数
export const getUnReadMsgCount = () => {
  return service({
    url: '/api/v3/other/message/unread_count',
    method: 'get'
  })
}
// 消息中心：设置消息已读
export const setMsgReadStatus = (data) => {
  return service({
    url: '/api/v3/other/message/set_read',
    method: 'get',
    params: data
  })
}

export const getCountData = (data = {}) => {
  return service({
    url: '/api/v3/menu/count/data',
    method: 'get',
    params: data
  })
}

// 查询置顶通知（旧的api，暂不使用/api/v3/other/top/notice）
export const getTopNotice = (data = {}) => {
  return service({
    url: '/api/v3/other/announcements',
    method: 'get',
    params: data
  })
}

// 公告：更新公告阅读数
export const updateAnnounceVisitNum = (data) => {
  return service({
    url: '/api/v3/other/announcements/vistnum',
    method: 'get',
    params: data
  })
}

// CRM：弹屏tab页签名称配置
export const getPopTabNameConfig = (host = '', data = {}) => {
  return service({
    url: host + '/api/options/popupTab',
    method: 'get',
    params: data
  })
}

export const postMenuItemSearch = (data = {}) => {
  return service({
    url: '/api/v3/menu/item/search',
    method: 'post',
    data
  })
}

// rtc视频客服按钮权限
export const checkRTCPermission = (host = '')=>{
  return service({
    url: host + '/v1/rtc/checkAgent',
    method: 'get',
    notShowErrMessage: true
  })
}
// 保存快捷菜单
export const postShortcutMenuSave = (data = {}) => {
  return service({
    url: '/api/v3/users/shortcut/menu/save',
    method: 'post',
    data
  })
}

// 外呼
export const callOut = (host, data = {}) => {
  return service({
    url: `${host}/api/v3/users/callOut`,
    method: 'post',
    data
  })
}

 //更改稍后联系状态
export const contactSolve = (host, data = {}) => {
  return service({
    url: `${host}/api/v3/contact/solve`,
    method: 'post',
    data
  })
}
//稍后联系
export const delayRemind = (host, data = {}) => {
  return service({
    url: `${host}/api/v3/contact/delayRemind`,
    method: 'post',
    data
  })
}

// 获取萝卜快跑部门id
export const getRadishGoPocDeptId = ()=>{
  return service({
    url: 'https://world.ysdor.cn/',
    method: 'get'
  })
}

// 获取其他系统配置
export const getOtherSystemConfig = (data = {}) => {
  return service({
    url: '/api/v3/other/system/settings',
    method: 'get',
    params: data
  })
}

// 获取新电话工作台配置
export const getSystemCcWorkbench = (data = {}) => {
  return service({
    url: '/api/v3/other/system/cc-workbench',
    method: 'get',
    params: data
  })
}

// // 判断是否企点用户
// export const qidianHasUser = (host, data = {}) => {
//   return {code: 0, message: "success", request_id: "7b8ead07-d15c-4e81-b5ff-25f02b51f292", data: {isHas: true}};
//   return service({
//     url: `${host}/api/v3/qidian/client/has-user`,
//     method: 'get',
//     params: data
//   })
// }






// WEBPACK FOOTER //
// ./src/api/index.js